/**
 * Parse URL query string to object using URLSearchParams API
 * This is a browser-safe alternative to the parseQuery function in helper.js
 * which has NodeRSA dependency that causes "process is not defined" error
 */
export const parseQuery = (queryString) => {
    const query = {};
    if (queryString) {
        const searchParams = new URLSearchParams(queryString);
        for (const [key, value] of searchParams.entries()) {
            try {
                // Try to parse as JSON first (for backward compatibility)
                query[key] = JSON.parse(decodeURIComponent(value));
            } catch {
                // If JSON parsing fails, use the value as string
                query[key] = decodeURIComponent(value);
            }
        }
    }
    return query;
}

/**
 * Simple parseQuery that just returns string values (recommended for new code)
 */
export const parseQuerySimple = (queryString) => {
    const query = {};
    if (queryString) {
        const searchParams = new URLSearchParams(queryString);
        for (const [key, value] of searchParams.entries()) {
            query[key] = value;
        }
    }
    return query;
}
